import React from "react";

import Instruction from "../../instruction";

const InstructionPage = () => {
  return <Instruction />;
};

export default InstructionPage;
